/* eslint-disable no-use-before-define */
const HEALTH_META = {
  NO_RULE: { label: 'Kural seçilmedi', variant: 'light-secondary' },
  PASSIVE: { label: 'Pasif', variant: 'light-secondary' },
  READY: { label: 'Hazır', variant: 'light-info' },
  HEALTHY: { label: 'Çalışıyor', variant: 'light-success' },
  WAITING_SIGNAL: { label: 'Sinyal bekliyor', variant: 'light-info' },
  PAIR_LOCKED: { label: 'Pair kilitli', variant: 'light-warning' },
  BALANCE_LOCKED: { label: 'Denge bekliyor', variant: 'light-warning' },
  BUDGET_BLOCKED: { label: 'Bütçe bloklu', variant: 'light-danger' },
  ASSIGNMENT_BLOCKED: { label: 'Atama bloklu', variant: 'light-danger' },
  RISKY: { label: 'Riskli matematik', variant: 'light-warning' },
}

const REASON_LABELS = {
  NO_CANDIDATE: 'uygun aday yok',
  NO_SKIP_REASON: 'skip yok',
  BUDGET_BLOCKED: 'bütçe engeli',
  DAILY_LIMIT_BLOCKED: 'günlük limit',
  EXECUTION_POLICY_BLOCKED: 'policy engeli',
  NO_ACTION: 'aksiyon yok',
  WAITING_CONFIRMATION: 'onay bekliyor',
  AUTO_ASSIGN_READY: 'otomatik atama hazır',
  AUTO_EXECUTE_READY: 'otomatik execute hazır',
  AUTO_PROTECT_READY: 'otomatik koruma hazır',
  BUDGET_ALLOWED: 'bütçe uygun',
  BOT_SELECTED: 'bot seçildi',
  BOT_CREATE_PLANNED: 'bot oluşturma planlandı',
  PAIR_ENTRY_REQUIRED: 'eşli atama karşı taraf bekliyor',
  ODD_SLOT_LOCK: 'tek slot kilidi',
  EXTRA_SLOT_SUGGESTED: '+1 slot önerisi',
  BUDGET_REJECTED: 'bütçe reddetti',
  MAX_OPEN_POSITIONS_LIMIT: 'maks açık pozisyon dolu',
  DAILY_NEW_POSITIONS_LIMIT: 'günlük pozisyon limiti dolu',
  TARGET_BUDGET_LIMIT: 'hedef bütçesi dolu',
  ASSIGNMENT_BLOCKED: 'bot ataması bloklandı',
  CREATE_NOT_ALLOWED: 'yeni bot oluşturma kapalı',
  BOT_NOT_AVAILABLE: 'uygun bot yok',
  BOT_LOCKED: 'bot kilitli',
  BOT_COOLDOWN: 'bot cooldown',
  POSITION_ALREADY_OPEN: 'pozisyon açık',
  SAME_SYMBOL_LIMIT: 'aynı coin limiti',
  INSUFFICIENT_MARGIN: 'margin yetersiz',
  DIRECTIONAL_BIAS_LIMIT: 'long/short yön dengesi',
  BALANCE_GOVERNOR_BLOCKED: 'pozisyon denge governor blokladı',
  BALANCE_ENTRY_BLOCKED: 'denge entry blokladı',
  BALANCE_ODD_SLOT_BLOCKED: 'denge tek slot blokladı',
  SEQUENTIAL_TRANSMISSION_WAIT_CLOSE: 'sıralı mod kapanış bekliyor',
  BALANCE_GOVERNOR_DISABLED: 'pozisyon denge governor kapalı',
  BALANCE_NO_ENTRY_SIDE: 'entry yönü okunamadı',
  BALANCE_PAIR_ENTRY_COMPLETE: 'eşli entry tamam',
  BALANCE_PAIR_ENTRY_REQUIRED: 'denge için karşı bacak gerekli',
  BALANCE_PAIR_ENTRY_RELAXED_FOR_REBALANCE: 'dengeyi düzeltmek için tek bacak serbest',
  BALANCE_ENTRY_ALLOWED: 'denge entry izni verdi',
  BALANCE_ENTRY_IMPROVES: 'entry dengeyi iyileştirir',
  BALANCE_ENTRY_NEUTRAL: 'entry dengeyi değiştirmez',
  BALANCE_ENTRY_WORSENS: 'entry dengeyi bozar',
  BALANCE_ENTRY_BLOCKED_STRICT: 'sıkı denge entry engeli',
  BALANCE_ENTRY_BLOCKED_IMBALANCED: 'dengesiz defterde entry bekletildi',
  BALANCE_ENTRY_BLOCKED_SIDE_GAP: 'side gap limiti aşıldı',
  LOW_SCORE_UNCERTAIN_MARKET_SWAP: 'düşük skor kararsız piyasa swapı',
  LOW_SCORE_SWAP_SUPPRESSED_SYMBOL_WIN_LEVELS: 'swap nedeniyle sembol-bazlı ağırlık bastırıldı',
  CRUISE_CONTROL_NOTIONAL_DAMPEN: 'cruise control notional farkını yumuşattı',
  BALANCE_ODD_SLOT_GOVERNOR_DISABLED: 'tek slot denge governor kapalı',
  BALANCE_ODD_SLOT_NOT_LOCKED: 'tek slot kilidi yok',
  BALANCE_ODD_SLOT_PAIR_CAPACITY_AVAILABLE: 'pair slot kapasitesi var',
  BALANCE_ODD_SLOT_WAIT: 'tek slotta bekle',
  BALANCE_ODD_SLOT_TRY_PROFIT_POCKET_UNLOCK: 'tek slot için kar sepeti kilit açmayı deniyor',
  BALANCE_ODD_SLOT_PROFIT_POCKET_UNAVAILABLE: 'tek slotu açacak kar sepeti yok',
  BALANCE_ODD_SLOT_SUGGEST_EXTRA_SLOT: '+1 slot önerildi',
  BALANCE_LOSS_OFFSET_PREFERENCE_ENABLED: 'zarar seçimi dengeye göre sıralandı',
  PAIR_COUNTER_REJECTED_SCORE: 'karşı aday skoru düşük',
  PAIR_COUNTER_REJECTED_CONFIDENCE: 'karşı aday güveni düşük',
  PAIR_COUNTER_REJECTED_DECAY: 'karşı aday sönümlenmiş',
  PAIR_COUNTER_REJECTED_LATE_ENTRY: 'karşı aday geç giriş riski taşıyor',
  PAIR_COUNTER_REJECTED_HEDGE_SYMBOL: 'sadece hedge açık; karşı aday aynı coin değil',
  PAIR_COUNTER_REJECTED_HEDGE_TIMEFRAME: 'sadece hedge açık; karşı aday aynı TF değil',
  PAIR_COUNTER_REJECTED_BUDGET: 'karşı aday bütçe engeli',
  PAIR_COUNTER_REJECTED_ASSIGNMENT: 'karşı aday atanamadı',
  PAIR_ASSIGNMENT_ENABLED: 'eşli atama aktif',
  PAIR_PRIMARY_SELECTED: 'ana aday seçildi',
  PAIR_COUNTER_TRIED: 'karşı aday denendi',
  PAIR_COUNTER_SELECTED: 'karşı aday seçildi',
  PAIR_ENTRY_EXECUTED: 'eşli entry çalıştı',
  DIRECT_COMPATIBLE_PAIR: 'uygun coin eşleşmesi',
  SAME_CORE_GROUP: 'ana piyasa coinleri eşleşti',
  SAME_ALT_GROUP: 'alt grup coinleri eşleşti',
  CORE_ALT_MISMATCH: 'core/alt uyumu zayıf',
  KNOWN_CROSS_GROUP_FALLBACK: 'cross grup fallback',
  UNKNOWN_SYMBOL_FALLBACK: 'bilinmeyen coin fallback',
  SAME_SYMBOL: 'aynı coin pair için uygun değil',
  PROFIT_HARVEST_READY: 'kar cebi kapanış hazır',
  PROFIT_HARVEST_BUDGET_MISSING: 'kar cebi bütçesi eksik',
  PROFIT_HARVEST_THRESHOLD_NOT_MET: 'kar cebi eşiği dolmadı',
  LOSS_OFFSET_READY: 'zarar karla kapatılabilir',
  PAIR_SCOPED_LOSS_OFFSET_NO_SAME_PAIR_COVER: 'aynı çiftte zarar cover yok',
  LOSS_OFFSET_LIMIT_ZERO: 'zarar kapatma limiti sıfır',
  LOSS_OFFSET_NOT_COVERED_BY_PROFIT: 'zararı kapatacak kar yok',
  LOSS_OFFSET_REQUIRES_PROFIT_HARVEST: 'kar alınmadan zarar kapatılmaz',
  LOSS_OFFSET_NO_LOSING_POSITION: 'eksi pozisyon yok',
  PROFIT_LOSS_CLEANUP_PROFIT_READY: 'cleanup kar kapanışı hazır',
  PROFIT_LOSS_CLEANUP_LOSS_READY: 'cleanup zarar kapanışı hazır',
  PROFIT_LOSS_CLEANUP_PARTIAL_READY: 'cleanup partial zarar hazır',
  PROFIT_LOSS_CLEANUP_PAIR_SCOPED_NO_SAME_PAIR_LOSS: 'cleanup aynı çiftte zarar bulamadı',
  BALANCE_DAMAGE_TRIM_READY: 'denge hasar kırpma hazır',
  BALANCE_DAMAGE_TRIM_PARTIAL_READY: 'denge hasarı parçalı kırpılacak',
  PROFIT_LOSS_CLEANUP_PROFIT_BUDGET_READY: 'cleanup kar bütçesi hazır',
  PROFIT_LOSS_CLEANUP_PROFIT_NOT_REALIZED: 'cleanup karı henüz gerçekleşmedi',
  PROFIT_LOSS_CLEANUP_BUDGET_RESELECTED: 'cleanup zarar bütçeye göre daraltıldı',
  PROFIT_BASKET_UNLOCK_AVAILABLE: 'kar sepeti kilit açabilir',
  PROFIT_BASKET_UNLOCK_EXECUTED: 'kar sepeti kilit açtı',
  PROFIT_BASKET_UNLOCK_REQUIRES_HARVEST: 'kilit için önce kar alınmalı',
  PROFIT_BASKET_UNLOCK_NO_LOSING_POSITION: 'kilit açacak eksi pozisyon yok',
  PROFIT_BASKET_UNLOCK_NOT_COVERED_BY_PROFIT: 'kilit için kar cover yetmedi',
  HEDGE_PAIR_LIFECYCLE_GENERIC_CLEANUP_GUARD_ACTIVE: 'hedge lifecycle generic cleanup koruması aktif',
  HEDGE_PAIR_LIFECYCLE_LOSER_TRIM_READY: 'hedge lifecycle loser kırpma hazır',
  HEDGE_PAIR_LIFECYCLE_LOSER_TRIM_PARTIAL_READY: 'hedge lifecycle loser parçalı kırpılacak',
  HEDGE_PAIR_LIFECYCLE_LOSER_TRIM_NOT_COVERED: 'hedge lifecycle loser kırpma için cover yetmedi',
  HEDGE_PAIR_LIFECYCLE_LOSER_MIN_LOSS_NOT_REACHED: 'hedge lifecycle loser zarar eşiğine gelmedi',
  HEDGE_PAIR_LIFECYCLE_MAX_TRIM_REACHED: 'hedge lifecycle maksimum kırpma sayısı doldu',
  HEDGE_PAIR_LIFECYCLE_POSITION_ALREADY_RESERVED: 'hedge lifecycle pozisyon başka aksiyona ayrılmış',
  HEDGE_PAIR_LIFECYCLE_NO_ACTION: 'hedge lifecycle aksiyon bekliyor',
  CLOSE_EXECUTOR_PENDING: 'close executor bekliyor',
  LIVE_CLOSE_EXECUTION_DISABLED: 'eski kayıt: LIVE close kapalı',
  PROFIT_POCKET_CLOSE_EXECUTED: 'kar cebi close çalıştı',
  PROFIT_POCKET_CLOSE_FAILED: 'kar cebi close hata',
  LIVE_CLOSE_CONFIRM_REQUIRED: 'LIVE close onayı gerekli',
  POSITION_NOT_OPEN: 'pozisyon açık değil',
  CLOSE_APPROVAL_EXECUTED: 'onayla close çalıştı',
  CLOSE_APPROVAL_FAILED: 'onayla close hata',
  RUNTIME_TP_HIT: 'runtime TP kapattı',
  RUNTIME_SL_HIT: 'runtime SL kapattı',
  DISCOVERY_BRIDGE_COMPLETED: 'sinyal taraması tamamlandı',
  SIGNAL_DISCOVERY_BRIDGE_PENDING: 'sinyal keşif köprüsü bekliyor',
  DISCOVERY_BRIDGE_ERROR: 'sinyal tarama köprüsü hata aldı',
}

function record(value) {
  return value && typeof value === 'object' ? value : {}
}

function array(value) {
  return Array.isArray(value) ? value : []
}

function number(value, fallback = 0) {
  const numeric = Number(value)
  return Number.isFinite(numeric) ? numeric : fallback
}

function positive(value, fallback = 0) {
  const numeric = number(value, fallback)
  return numeric > 0 ? numeric : fallback
}

function money(value) {
  const numeric = number(value, 0)
  let sign = ''
  if (numeric > 0) sign = '+'
  if (numeric < 0) sign = '-'
  return `${sign}${Math.abs(numeric).toFixed(2)} USDT`
}

function pct(value) {
  return `%${number(value, 0).toFixed(2)}`
}

function count(value) {
  return number(value, 0).toFixed(0)
}

function dominantReason(decisions) {
  const counts = {}
  array(decisions).forEach(decision => {
    const reason = String(decision.skipReason || '')
    if (!reason) return
    counts[reason] = (counts[reason] || 0) + 1
  })
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))[0] || null
}

function budgetBase(rule, form) {
  const budget = record(rule.budget || form.budget)
  const margin = positive(form.maxPerPositionMarginUsdt ?? budget.maxPerPositionMarginUsdt, 0)
  const maxOpen = positive(form.maxOpenPositions ?? budget.maxOpenPositions, 0)
  return positive(
    rule.targetBudgetUsdt
      ?? rule.budgetBaseUsdt
      ?? budget.targetBudgetUsdt
      ?? budget.maxTotalOpenMarginUsdt,
    margin * maxOpen,
  )
}

function runtime(rule, form) {
  const cfg = record(rule.runtimeConfig)
  return {
    marginPerBot: positive(form.maxPerPositionMarginUsdt ?? cfg.marginPerBot, positive(record(rule.budget).maxPerPositionMarginUsdt, 0)),
    leverage: positive(form.leverage ?? cfg.leverage, 10),
    tpPerc: positive(form.tpPerc ?? cfg.tpPerc, 2.5),
    slPerc: positive(form.slPerc ?? cfg.slPerc, 1),
    commissionPerSide: number(form.commissionPerSide ?? cfg.commissionPerSide, 0.05),
  }
}

function opportunity(rule, form) {
  const policy = record(rule.opportunityPolicy)
  const hasFormHarvestScope = Object.prototype.hasOwnProperty.call(form, 'harvestScopeBot')
  const hasFormLossMode = Object.prototype.hasOwnProperty.call(form, 'lossOffsetLargestFirst')
  let harvestScope = String(policy.harvestScope || 'BASKET')
  if (hasFormHarvestScope) {
    harvestScope = form.harvestScopeBot === true ? 'BOT' : 'BASKET'
  }
  let lossOffsetSelectionMode = String(policy.lossOffsetSelectionMode || 'LARGEST_LOSS')
  if (hasFormLossMode) {
    lossOffsetSelectionMode = form.lossOffsetLargestFirst === true ? 'LARGEST_LOSS' : 'SMALLEST_LOSS'
  }
  return {
    harvestProfitablePositions: form.harvestProfitablePositions ?? policy.harvestProfitablePositions === true,
    harvestScope,
    harvestBudgetPct: number(form.harvestBudgetPct ?? policy.harvestBudgetPct, 10),
    profitCloseMinPnlPct: number(form.profitCloseMinPnlPct ?? policy.profitCloseMinPnlPct, 0),
    lossOffsetCloseEnabled: form.lossOffsetCloseEnabled ?? policy.lossOffsetCloseEnabled === true,
    requireProfitHarvestForLossOffset: form.requireProfitHarvestForLossOffset ?? policy.requireProfitHarvestForLossOffset === true,
    lossOffsetProfitMultipleEnabled: form.lossOffsetProfitMultipleEnabled ?? policy.lossOffsetProfitMultipleEnabled === true,
    lossOffsetProfitMultiple: positive(form.lossOffsetProfitMultiple ?? policy.lossOffsetProfitMultiple, 1),
    lossOffsetMinLossPct: number(form.lossOffsetMinLossPct ?? policy.lossOffsetMinLossPct, 0),
    lossOffsetSelectionMode,
    partialLossCloseEnabled: form.partialLossCloseEnabled ?? policy.partialLossCloseEnabled === true,
    partialLossCloseAllEligible: form.partialLossCloseAllEligible ?? policy.partialLossCloseAllEligible === true,
    partialLossCloseThresholdEnabled: form.partialLossCloseThresholdEnabled ?? policy.partialLossCloseThresholdEnabled === true,
    partialLossCloseThresholdPnlPct: number(form.partialLossCloseThresholdPnlPct ?? policy.partialLossCloseThresholdPnlPct, 0),
    partialLossClosePercent: positive(form.partialLossClosePercent ?? policy.partialLossClosePercent, 25),
    maxPartialLossOffsetsPerRun: Math.max(0, number(form.maxPartialLossOffsetsPerRun ?? policy.maxPartialLossOffsetsPerRun, 1)),
    timedLossOffsetEnabled: form.timedLossOffsetEnabled ?? policy.timedLossOffsetEnabled === true,
    timedLossOffsetIntervalMinutes: positive(form.timedLossOffsetIntervalMinutes ?? policy.timedLossOffsetIntervalMinutes, 60),
    timedLossOffsetMinLossPct: number(form.timedLossOffsetMinLossPct ?? policy.timedLossOffsetMinLossPct, 0),
    rapidLossCloseEnabled: form.rapidLossCloseEnabled ?? policy.rapidLossCloseEnabled === true,
    rapidLossCloseWindowMinutes: positive(form.rapidLossCloseWindowMinutes ?? policy.rapidLossCloseWindowMinutes, 10),
    rapidLossCloseMinLossPct: number(form.rapidLossCloseMinLossPct ?? policy.rapidLossCloseMinLossPct, 0.75),
    maxRapidLossClosesPerRun: Math.max(0, number(form.maxRapidLossClosesPerRun ?? policy.maxRapidLossClosesPerRun, 1)),
    distributeRealizedProfitToPositionsEnabled: form.distributeRealizedProfitToPositionsEnabled ?? policy.distributeRealizedProfitToPositionsEnabled === true,
    realizedProfitDistributionTiming: String(form.realizedProfitDistributionTiming ?? policy.realizedProfitDistributionTiming ?? 'ACTIVE_AND_CLOSED_BUDGET'),
  }
}

export function buildSignalAutomationParameterAccounting(input = {}) {
  const rule = record(input.rule)
  const form = record(input.form)
  const rt = runtime(rule, form)
  const op = opportunity(rule, form)
  const baseBudget = positive(input.targetBudgetUsdt, budgetBase(rule, form))
  const notional = rt.marginPerBot * rt.leverage
  const tpGross = notional * (rt.tpPerc / 100)
  const slGross = notional * (rt.slPerc / 100)
  const feePerSide = Math.max(0, notional * (rt.commissionPerSide / 100))
  const roundTripFee = feePerSide * 2
  const netTp = tpGross - roundTripFee
  const netSl = -(slGross + roundTripFee)
  const profitPocketTarget = op.harvestProfitablePositions ? baseBudget * (op.harvestBudgetPct / 100) : 0
  const profitCloseMinGross = notional * (op.profitCloseMinPnlPct / 100)
  const lossOffsetMinGross = notional * (op.lossOffsetMinLossPct / 100)
  const requiredNetProfitForMinLoss = op.lossOffsetProfitMultipleEnabled
    ? lossOffsetMinGross * op.lossOffsetProfitMultiple
    : lossOffsetMinGross
  const partialLossGross = lossOffsetMinGross * (op.partialLossClosePercent / 100)
  const rapidLossGross = notional * (op.rapidLossCloseMinLossPct / 100)
  const requiredNetProfitForPartialLoss = op.lossOffsetProfitMultipleEnabled
    ? partialLossGross * op.lossOffsetProfitMultiple
    : partialLossGross
  const maxCoveredLossByNetTp = op.lossOffsetProfitMultiple > 0
    ? Math.max(0, netTp) / op.lossOffsetProfitMultiple
    : Math.max(0, netTp)
  const pairMargin = rt.marginPerBot * 2

  const rows = [
    row('entry-margin', 'Giriş bütçesi', 'Bot başı margin', money(rt.marginPerBot), `Kaldıraç ${rt.leverage}x`),
    row('entry-notional', 'Giriş bütçesi', 'Pozisyon notional', money(notional), 'margin x kaldıraç'),
    row('tp-gross', 'TP / SL hesabı', `TP ${pct(rt.tpPerc)}`, money(tpGross), 'brüt kâr'),
    row('sl-gross', 'TP / SL hesabı', `SL ${pct(rt.slPerc)}`, money(-slGross), 'brüt zarar', 'danger'),
    row('fee', 'Komisyon', 'Round-trip komisyon', money(-roundTripFee), `${money(-feePerSide)} giriş + ${money(-feePerSide)} çıkış`, 'warning'),
    row('tp-net', 'Net sonuç', 'Net TP', money(netTp), 'TP brüt - round-trip komisyon', netTp >= 0 ? 'success' : 'danger'),
    row('sl-net', 'Net sonuç', 'Net SL', money(netSl), 'SL brüt + round-trip komisyon', 'danger'),
    row('harvest-target', 'Kar cebi', `Kar cebi hedef ${pct(op.harvestBudgetPct)}`, op.harvestProfitablePositions ? money(profitPocketTarget) : 'Kapalı', `baz bütçe ${money(baseBudget)}`),
    row('profit-min', 'Kar cebi', `Kar kapat min ${pct(op.profitCloseMinPnlPct)}`, money(profitCloseMinGross), 'tek pozisyon brüt minimum'),
    row('loss-min', 'Zarar kapatma', `Min zarar ${pct(op.lossOffsetMinLossPct)}`, op.lossOffsetCloseEnabled ? money(-lossOffsetMinGross) : 'Kapalı', 'zarar temizliği için minimum zarar', 'warning'),
    row('loss-priority', 'Zarar kapatma', 'Temizlik sırası', op.lossOffsetSelectionMode === 'SMALLEST_LOSS' ? 'En düşük zarar' : 'En yüksek zarar', 'zarar adayları bu sıraya göre denenir'),
    row('loss-multiple', 'Zarar kapatma', `Zarar katı ${op.lossOffsetProfitMultiple.toFixed(2)}x`, op.lossOffsetCloseEnabled ? money(requiredNetProfitForMinLoss) : 'Kapalı', `${money(-lossOffsetMinGross)} zarar için gereken net kar`),
    row('loss-cover-by-tp', 'Zarar kapatma', '1 net TP ile kapanabilecek zarar', op.lossOffsetCloseEnabled ? money(-maxCoveredLossByNetTp) : 'Kapalı', 'net TP / zarar katı'),
    row('partial-loss-close', 'Parçalı zarar', `Partial ${pct(op.partialLossClosePercent)}`, op.partialLossCloseEnabled ? money(-partialLossGross) : 'Kapalı', `tek run max ${op.maxPartialLossOffsetsPerRun}`),
    row('partial-loss-cover', 'Parçalı zarar', 'Partial için gereken net kar', op.partialLossCloseEnabled ? money(requiredNetProfitForPartialLoss) : 'Kapalı', op.partialLossCloseThresholdEnabled ? `eşik ${pct(op.partialLossCloseThresholdPnlPct)}` : 'zarar min filtresi korunur'),
    row('timed-loss', 'Zamanlı zarar', `${op.timedLossOffsetIntervalMinutes} dk / ${pct(op.timedLossOffsetMinLossPct)}`, op.timedLossOffsetEnabled ? money(-(notional * (op.timedLossOffsetMinLossPct / 100))) : 'Kapalı', 'diğer kuralları ezmeden izler'),
    row('rapid-loss', 'Hızlı zarar kesici', `${op.rapidLossCloseWindowMinutes} dk / ${pct(op.rapidLossCloseMinLossPct)}`, op.rapidLossCloseEnabled ? money(-rapidLossGross) : 'Kapalı', `kar sepeti beklemez · max/run ${op.maxRapidLossClosesPerRun}`, 'danger'),
    row(
      'realized-profit-distribution',
      'Realize kâr paylaştırma',
      op.distributeRealizedProfitToPositionsEnabled ? 'Açık' : 'Kapalı',
      op.distributeRealizedProfitToPositionsEnabled
        ? realizedProfitDistributionTimingLabel(op.realizedProfitDistributionTiming)
        : 'realize +PnL pozisyon bütçelerine dağıtılmaz',
      op.distributeRealizedProfitToPositionsEnabled ? 'success' : 'secondary',
    ),
    row('pair-margin', 'Pair / slot', 'Eşli atama maliyeti', money(pairMargin), 'LONG + SHORT için gereken margin'),
  ]

  const warnings = []
  if (netTp <= 0) warnings.push('Net TP komisyon sonrası pozitif değil.')
  if (op.lossOffsetCloseEnabled && requiredNetProfitForMinLoss > Math.max(0, netTp)) {
    warnings.push(`Tek net TP, minimum zarar kapatma ihtiyacını karşılamıyor: ${money(netTp)} / ${money(requiredNetProfitForMinLoss)}.`)
  }
  if (op.harvestProfitablePositions && profitPocketTarget > Math.max(0, netTp) && op.harvestScope === 'BOT') {
    warnings.push('Bot özelinde kar cebi hedefi tek net TP seviyesinden yüksek görünüyor.')
  }
  if (rt.slPerc > 0 && rt.tpPerc > 0 && Math.abs(netSl) > Math.max(0, netTp) * 3) {
    warnings.push('Net SL, net TP’ye göre çok büyük; strateji kar cebi ve zarar katı disiplinine bağımlı.')
  }

  return {
    runtime: rt,
    opportunity: op,
    baseBudget,
    notional,
    tpGross,
    slGross,
    feePerSide,
    roundTripFee,
    netTp,
    netSl,
    profitPocketTarget,
    profitCloseMinGross,
    lossOffsetMinGross,
    partialLossGross,
    rapidLossGross,
    requiredNetProfitForPartialLoss,
    requiredNetProfitForMinLoss,
    maxCoveredLossByNetTp,
    pairMargin,
    rows,
    warnings,
  }
}

export function buildSignalAutomationLiveStrategyReading(input = {}) {
  const rule = record(input.rule)
  const form = record(input.form)
  const latestRun = record(input.latestRun)
  const decisions = array(input.decisions)
  const assignment = record(rule.assignment)
  const budget = record(rule.budget)
  const accounting = buildSignalAutomationParameterAccounting(input)
  const dominant = dominantReason(decisions)
  const runSummary = record(latestRun.summary)
  const snapshotRows = buildSnapshotRows(runSummary)
  const activePairDirectionRows = buildActivePairDirectionRows(runSummary)
  const strategyAccountingRows = buildStrategyAccountingRows({
    runSummary,
    decisions,
    accounting,
  })
  const counters = {
    scanned: number(latestRun.scannedCount, 0),
    matched: number(latestRun.matchedCount, 0),
    queued: number(latestRun.queuedCount, 0),
    assigned: number(latestRun.assignedCount, 0),
    executed: number(latestRun.executedCount, 0),
    skipped: number(latestRun.skippedCount, 0),
    rejected: number(latestRun.rejectedCount, 0),
  }
  const status = resolveHealthState({
    rule,
    latestRun,
    decisions,
    dominantReasonCode: dominant ? dominant[0] : null,
    accounting,
    runSummary,
  })
  const meta = HEALTH_META[status] || HEALTH_META.READY
  const summary = buildSummary({
    rule,
    form,
    assignment,
    budget,
    latestRun,
    counters,
    dominant,
    accounting,
    runSummary,
    snapshotRows,
    activePairDirectionRows,
  })
  return {
    status,
    modeLabel: meta.label,
    badgeVariant: meta.variant,
    summary,
    counters,
    accounting,
    snapshotRows,
    activePairDirectionRows,
    strategyAccountingRows,
    runSummary,
    warnings: accounting.warnings,
    dominantReason: dominant ? {
      code: dominant[0],
      count: dominant[1],
      label: reasonLabel(dominant[0]),
    } : null,
  }
}

function resolveHealthState(input) {
  if (!input.rule || !input.rule.id) return 'NO_RULE'
  if (input.rule.enabled === false) return 'PASSIVE'
  if (!input.latestRun || !input.latestRun.id) return 'READY'
  const balanceGovernor = record(input.runSummary && input.runSummary.balanceGovernorSummary)
  const balanceSnapshot = record(balanceGovernor.snapshot)
  if (
    balanceGovernor.enabled === true
    && (balanceSnapshot.balanced === false || balanceSnapshot.oddSlotLocked === true)
  ) return 'BALANCE_LOCKED'
  const pair = record(input.runSummary && input.runSummary.pairAssignmentSummary)
  if (pair.enabled === true && ['COUNTER_NOT_FOUND', 'PAIR_REQUIRED', 'ODD_SLOT_LOCKED'].includes(String(pair.status))) return 'PAIR_LOCKED'
  const pocket = record(input.runSummary && input.runSummary.profitPocketSummary)
  if (pocket.enabled === true && array(pocket.skippedReasons).some(reason => String(reason).includes('BUDGET'))) return 'BUDGET_BLOCKED'
  const reason = String(input.dominantReasonCode || '')
  if (reason.includes('BUDGET') || reason.includes('MAX_OPEN') || reason.includes('MARGIN')) return 'BUDGET_BLOCKED'
  if (reason.includes('ASSIGNMENT') || reason.includes('BOT') || reason.includes('CREATE')) return 'ASSIGNMENT_BLOCKED'
  if (reason.includes('PAIR') || reason.includes('ODD_SLOT') || reason.includes('EXTRA_SLOT')) return 'PAIR_LOCKED'
  if (number(input.latestRun.matchedCount, 0) === 0) return 'WAITING_SIGNAL'
  if (array(input.accounting && input.accounting.warnings).length) return 'RISKY'
  return 'HEALTHY'
}

function buildSummary(input) {
  const lines = []
  const pairEnabled = input.form.pairBalancedEntriesEnabled ?? input.assignment.pairBalancedEntriesEnabled === true
  const hedgeOnlyEnabled = input.form.pairHedgeOnlyEnabled ?? input.assignment.pairHedgeOnlyEnabled === true
  const suitableEnabled = input.form.pairSuitableCoinsEnabled ?? input.assignment.pairSuitableCoinsEnabled === true
  const longShortEnabled = input.form.longShortBalanceEnabled ?? input.budget.longShortBalanceEnabled === true
  const balanceGovernor = record(input.runSummary.balanceGovernorSummary)
  const balanceSnapshot = record(balanceGovernor.snapshot)
  if (input.rule.enabled === false) {
    lines.push('Kural pasif; scheduler bu kuraldan yeni karar üretmez.')
  } else if (!input.latestRun.id) {
    lines.push('Kural hazır; henüz okunacak run yok.')
  } else {
    lines.push(`Son run ${input.counters.scanned} tarama / ${input.counters.matched} eşleşme / ${input.counters.executed} execution üretti.`)
  }
  if (input.dominant) {
    lines.push(`Baskın blok: ${reasonLabel(input.dominant[0])} (${input.dominant[1]} karar).`)
  }
  lines.push(...buildOperationalSummaryLines(input.runSummary))
  if (pairEnabled) {
    if (hedgeOnlyEnabled) {
      lines.push('Sadece hedge açık; sistem LONG/SHORT çiftleri aynı coin üzerinde kurar, aynı coin karşı yön yoksa bekler.')
    } else if (suitableEnabled) {
      lines.push('Eşli atama ve uygun coin eşleştirme açık; sistem LONG/SHORT çiftte coin uyumunu öncelemeye çalışır.')
    } else {
      lines.push('Eşli atama açık; sistem tek taraflı entry yerine karşı tarafı bekler.')
    }
  }
  if (longShortEnabled) {
    lines.push('Long/short denge açık; taraf baskısı yeni aday seçiminde dikkate alınır.')
  }
  if (balanceGovernor.enabled === true) {
    const modeLabel = balanceModeLabel(balanceGovernor.mode)
    if (Object.keys(balanceSnapshot).length) {
      lines.push(`Pozisyon Denge Governor açık: ${modeLabel} · LONG ${count(balanceSnapshot.openLongCount)} / SHORT ${count(balanceSnapshot.openShortCount)} · side gap ${count(balanceSnapshot.sideGap)}.`)
    } else {
      lines.push(`Pozisyon Denge Governor açık: ${modeLabel}.`)
    }
    if (balanceSnapshot.oddSlotLocked === true) {
      lines.push(`Tek slot kilidi aktif; policy ${balanceOddSlotPolicyLabel(balanceGovernor.oddSlotPolicy)}.`)
    }
    if (balanceGovernor.rebalanceProtectionEnabled === true) {
      lines.push(`Rebalance koruma açık; eksik taraf ${count(balanceGovernor.rebalanceProtectionGraceMinutes)} dk sonra -%${number(balanceGovernor.rebalanceProtectionMaxLossPct, 0).toFixed(2)} eşiğinde erken kapatılır, max/run ${count(balanceGovernor.rebalanceProtectionMaxClosesPerRun)}.`)
    }
    if (array(input.activePairDirectionRows).length) {
      lines.push(`Aktif pozisyon yön tablosu ${count(input.activePairDirectionRows.length)} çift/pozisyon izliyor.`)
    }
  }
  if (input.accounting.profitPocketTarget > 0) {
    lines.push(`Kar cebi ${money(input.accounting.profitPocketTarget)} seviyesinde tetiklenir; net TP ${money(input.accounting.netTp)}.`)
  }
  if (input.accounting.requiredNetProfitForMinLoss > 0) {
    lines.push(`Minimum zarar temizliği için gereken net kar ${money(input.accounting.requiredNetProfitForMinLoss)}.`)
  }
  return lines
}

function buildActivePairDirectionRows(runSummary) {
  const balanceGovernor = record(record(runSummary).balanceGovernorSummary)
  return array(balanceGovernor.activePositionDirectionRows).map(row => {
    const item = record(row)
    const pnlValue = number(item.pnlUsdt, 0)
    const pair = String(item.pairLabel || item.key || '-')
    const direction = `skor ${number(item.directionScore, 0).toFixed(0)} · L ${number(item.longScore, 0).toFixed(0)} / S ${number(item.shortScore, 0).toFixed(0)}`
    const exposure = `${money(item.marginUsdt)} · ${String(item.leverageText || '-')} · notional ${money(item.notionalUsdt)}`
    const pnlPercent = item.pnlPercent === null || item.pnlPercent === undefined
      ? ''
      : ` · ${pct(item.pnlPercent)}`
    return {
      ...item,
      pair,
      direction,
      exposure,
      pnl: `${money(pnlValue)}${pnlPercent}`,
      variant: pnlValue >= 0 ? 'success' : 'danger',
      detail: String(item.detail || ''),
    }
  })
}

function buildOperationalSummaryLines(summary) {
  const lines = []
  const pair = record(summary.pairAssignmentSummary)
  const compatibility = record(pair.compatibilitySummary)
  const pocket = record(summary.profitPocketSummary)
  const runtimeStop = record(summary.runtimeStopGuardSummary)
  const immediate = record(summary.immediateAssignmentSummary)
  if (pair.enabled === true) {
    const status = String(pair.status || '')
    if (status === 'COUNTER_SELECTED') {
      lines.push(`Pair bulundu: ${pair.primarySide || 'ana'} / ${pair.counterSide || 'karşı'} birlikte atanabilir.`)
    } else if (status) {
      lines.push(`Pair durumu: ${reasonLabel(status)}${reasonListText(pair.reasons)}.`)
    }
    if (compatibility.enabled === true) {
      const score = number(compatibility.selectedScore, NaN)
      const compatibilityScoreText = Number.isFinite(score) ? `uyum ${score.toFixed(2)}` : 'uyum ölçüldü'
      lines.push(compatibility.selectedLabel || `Uygun coin eşleştirme açık; ${compatibilityScoreText}.`)
    }
  }
  if (pocket.enabled === true) {
    lines.push(`Kar cebi: hedef ${money(pocket.targetHarvestUsdt)} · artı PnL ${money(pocket.positivePnlUsdt)} · eksi PnL ${money(pocket.negativePnlUsdt)}.`)
    const distribution = record(pocket.realizedProfitDistributionSummary)
    if (distribution.enabled === true) {
      lines.push(`Realize kâr paylaştırma açık: ${realizedProfitDistributionTimingLabel(distribution.timing)} · bot başı tahmini ${money(distribution.estimatedActivePositionShareUsdt)}.`)
    }
    if (pocket.lossOffsetSelectionMode) {
      lines.push(`Zarar temizleme sırası: ${pocket.lossOffsetSelectionMode === 'SMALLEST_LOSS' ? 'en düşük zarar önce' : 'en yüksek zarar önce'}.`)
    }
    if (pocket.partialLossCloseEnabled === true) {
      lines.push(`Parçalı zarar kapatma açık: pozisyonun ${pct(number(pocket.partialLossClosePercent, 25))} kadarı, tek run max ${count(pocket.maxPartialLossOffsetsPerRun)} karar.`)
    }
    const skipped = array(pocket.skippedReasons)
    if (skipped.length) lines.push(`Kar cebi bekleme nedeni: ${skipped.slice(0, 2).map(reasonLabel).join(' · ')}.`)
  }
  const cleanup = record(pocket.profitLossCleanupSummary)
  if (cleanup.enabled === true) {
    const selectedProfitCount = count(cleanup.selectedProfitCount ?? array(cleanup.selectedProfitPositions).length)
    const selectedLossCount = count(cleanup.selectedLossCount ?? array(cleanup.selectedLossPositions).length)
    lines.push(`Profit Loss Cleanup: mod ${cleanupModeLabel(cleanup.mode)} · kar ${selectedProfitCount} / zarar ${selectedLossCount} · budget ${money(cleanup.estimatedCleanupBudgetUsdt)}.`)
    if (cleanup.partialLossEnabled === true) {
      lines.push('Cleanup partial zarar açık; sığmayan zararlar bütçeye göre daraltılır.')
    }
    const rejected = array(cleanup.rejectedReasons)
    if (rejected.length) lines.push(`Cleanup bekleme nedeni: ${rejected.slice(0, 2).map(reasonLabel).join(' · ')}.`)
  }
  const safeClose = record(pocket.safeCloseSummary)
  if (safeClose.enabled === true) {
    lines.push(`Güvenli kapatma: ${safeCloseStatusLabel(safeClose.status)} · cover ${money(safeClose.availableProfitCoverUsdt)} / zarar ${money(safeClose.lossAbsUsdt)}.`)
    const rejected = array(safeClose.rejectedReasons)
    if (rejected.length) lines.push(`Güvenli kapatma bekleme nedeni: ${rejected.slice(0, 2).map(reasonLabel).join(' · ')}.`)
  }
  if (runtimeStop.closed > 0 || runtimeStop.failed > 0 || runtimeStop.skipped > 0) {
    lines.push(`Runtime stop: kapanan ${count(runtimeStop.closed)} · skip ${count(runtimeStop.skipped)} · hata ${count(runtimeStop.failed)}.`)
  }
  if (immediate.enabled === true) {
    lines.push(`Derhal atama açık; gevşetilen aday ${count(immediate.relaxedCount)} · sert red ${count(immediate.hardRejectedCount)}.`)
  }
  return lines
}

function buildSnapshotRows(summary) {
  const rows = []
  const scan = record(summary.scanSummary)
  const pair = record(summary.pairAssignmentSummary)
  const compatibility = record(pair.compatibilitySummary)
  const pocket = record(summary.profitPocketSummary)
  const runtimeStop = record(summary.runtimeStopGuardSummary)
  const balance = record(summary.directionalBalanceSummary)
  const balanceGovernor = record(summary.balanceGovernorSummary)
  const immediate = record(summary.immediateAssignmentSummary)
  if (Object.keys(scan).length) {
    rows.push(snapshotRow('scan', 'Tarama', `${count(scan.rawSignals)} ham sinyal`, scanDetail(scan)))
  }
  if (pair.enabled === true) {
    rows.push(snapshotRow('pair', 'Eşli atama', reasonLabel(pair.status), pairDetail(pair)))
  }
  if (compatibility.enabled === true) {
    rows.push(snapshotRow(
      'compatibility',
      'Uygun pair',
      compatibility.fallbackUsed === true ? 'fallback' : scoreText(compatibility.selectedScore),
      compatibility.selectedLabel || reasonListText(compatibility.selectedReasons).replace(/^ · /, ''),
      compatibility.fallbackUsed === true ? 'warning' : 'success',
    ))
  }
  if (Object.keys(balance).length) {
    rows.push(snapshotRow('balance', 'Yön dengesi', balance.allowed === false ? 'blok' : 'izleniyor', balanceDetail(balance), balance.allowed === false ? 'warning' : 'secondary'))
  }
  if (balanceGovernor.enabled === true) {
    rows.push(snapshotRow(
      'balance-governor',
      'Pozisyon dengesi',
      balanceGovernorSnapshotValue(balanceGovernor),
      balanceGovernorDetail(balanceGovernor),
      balanceGovernorVariant(balanceGovernor),
    ))
    const profitPocketBalance = record(balanceGovernor.profitPocket)
    if (profitPocketBalance.enabled === true) {
      rows.push(snapshotRow(
        'balance-loss-offset',
        'Denge zarar seçimi',
        profitPocketBalance.preferredLossOffsetSide || 'izleniyor',
        balanceProfitPocketDetail(profitPocketBalance),
        array(profitPocketBalance.lossOffsetPreferenceReasons).length ? 'info' : 'secondary',
      ))
    }
  }
  if (pocket.enabled === true) {
    rows.push(snapshotRow('profit-pocket', 'Kar cebi', `${money(pocket.positivePnlUsdt)} / ${money(pocket.targetHarvestUsdt)}`, profitPocketDetail(pocket), pocket.decisionCount > 0 ? 'success' : 'secondary'))
    const distribution = record(pocket.realizedProfitDistributionSummary)
    if (distribution.enabled === true) {
      rows.push(snapshotRow(
        'realized-profit-distribution',
        'Realize kâr paylaştırma',
        realizedProfitDistributionTimingShortLabel(distribution.timing),
        realizedProfitDistributionDetail(distribution),
        'success',
      ))
    }
  }
  const cleanup = record(pocket.profitLossCleanupSummary)
  if (cleanup.enabled === true) {
    let cleanupVariant = 'secondary'
    if (cleanup.decisionCount > 0) cleanupVariant = 'success'
    else if (array(cleanup.rejectedReasons).length) cleanupVariant = 'warning'
    rows.push(snapshotRow(
      'profit-loss-cleanup',
      'Profit Loss Cleanup',
      `${count(cleanup.selectedProfitCount ?? array(cleanup.selectedProfitPositions).length)} kar / ${count(cleanup.selectedLossCount ?? array(cleanup.selectedLossPositions).length)} zarar`,
      profitLossCleanupDetail(cleanup),
      cleanupVariant,
    ))
  }
  const safeClose = record(pocket.safeCloseSummary)
  if (safeClose.enabled === true) {
    rows.push(snapshotRow(
      'safe-close',
      'Güvenli kapatma',
      safeCloseStatusLabel(safeClose.status),
      safeCloseDetail(safeClose),
      safeClose.canCloseNow === true ? 'success' : 'warning',
    ))
  }
  if (runtimeStop.closed > 0 || runtimeStop.skipped > 0 || runtimeStop.failed > 0) {
    rows.push(snapshotRow('runtime-stop', 'TP/SL guard', `${count(runtimeStop.closed)} kapandı`, `skip ${count(runtimeStop.skipped)} · hata ${count(runtimeStop.failed)}`, runtimeStop.failed > 0 ? 'danger' : 'success'))
  }
  if (immediate.enabled === true) {
    rows.push(snapshotRow('immediate', 'Derhal atama', `${count(immediate.relaxedCount)} gevşetildi`, reasonListText(immediate.relaxedReasons).replace(/^ · /, '') || `${count(immediate.hardRejectedCount)} sert red`))
  }
  return rows
}

function buildStrategyAccountingRows(input) {
  const summary = record(input.runSummary)
  const pocketSummary = record(summary.profitPocketSummary)
  const executionSummary = record(summary.executionSummary)
  const decisions = array(input.decisions)
  const openPositive = number(pocketSummary.positivePnlUsdt, 0)
  const openNegative = number(pocketSummary.negativePnlUsdt, 0)
  const openNet = openPositive + openNegative
  const realizedBuffer = number(pocketSummary.realizedProfitBufferUsdt, 0)
  const pocketValues = decisions.map(decisionProfitPocket)
  const pendingPocket = pocketValues.filter(item => item.type && !item.executed && !item.failed)
  const executedPocket = pocketValues.filter(item => item.executed)
  const pendingProfitHarvest = sumPocket(pendingPocket, item => item.type === 'PROFIT_HARVEST')
  const pendingLossOffset = sumPocket(pendingPocket, item => item.type === 'LOSS_OFFSET')
  const pendingPairUnlock = sumPocket(pendingPocket, item => item.type === 'PAIR_UNLOCK')
  const pendingCleanupProfit = sumPocket(pendingPocket, item => item.type === 'PROFIT_LOSS_CLEANUP_PROFIT')
  const pendingCleanupLoss = sumPocket(pendingPocket, item => item.type === 'PROFIT_LOSS_CLEANUP_LOSS')
  const pendingCleanupBudget = sumPocket(pendingPocket, item => item.type === 'PROFIT_LOSS_CLEANUP_LOSS', 'plannedLossCoverUsdt')
  const executedCleanupProfit = sumPocket(executedPocket, item => item.type === 'PROFIT_LOSS_CLEANUP_PROFIT', 'realizedPnl')
  const executedCleanupLoss = sumPocket(executedPocket, item => item.type === 'PROFIT_LOSS_CLEANUP_LOSS', 'realizedPnl')
  const cleanupReselectCount = pendingPocket
    .concat(executedPocket)
    .filter(item => item.type === 'PROFIT_LOSS_CLEANUP_LOSS' && item.budgetReselected === true)
    .length
  const executedClose = sumPocket(executedPocket, () => true, 'realizedPnl')
  const estimatedFees = sumPocket(pocketValues, item => item.type !== null, 'estimatedCommissionUsdt')
  const pendingCloseNet = pendingProfitHarvest + pendingLossOffset + pendingPairUnlock + pendingCleanupProfit + pendingCleanupLoss
  const rows = [
    accountingRow('realized-buffer', 'Realized tampon', money(realizedBuffer), 'hedefte kayıtlı realize kar tamponu', realizedBuffer > 0 ? 'success' : 'secondary'),
    accountingRow('open-positive', 'Açık artı PnL', money(openPositive), 'kar cebi aday havuzu', openPositive > 0 ? 'success' : 'secondary'),
    accountingRow('open-negative', 'Açık eksi PnL', money(openNegative), 'zarar offset aday havuzu', openNegative < 0 ? 'danger' : 'secondary'),
    accountingRow('open-net', 'Açık sepet net', money(openNet), 'artı + eksi açık PnL', openNet >= 0 ? 'success' : 'danger'),
    accountingRow('pending-profit', 'Bekleyen kar cebi', money(pendingProfitHarvest), 'henüz execute edilmemiş profit harvest close kararları', pendingProfitHarvest > 0 ? 'success' : 'secondary'),
    accountingRow('pending-loss', 'Bekleyen zarar offset', money(pendingLossOffset + pendingPairUnlock), 'karla kapatılması planlanan zarar close kararları', pendingLossOffset + pendingPairUnlock < 0 ? 'warning' : 'secondary'),
    accountingRow('cleanup-pending-profit', 'Cleanup bekleyen kar', money(pendingCleanupProfit), 'önce gerçekleşmesi gereken cleanup kar close kararları', pendingCleanupProfit > 0 ? 'success' : 'secondary'),
    accountingRow('cleanup-pending-loss', 'Cleanup bekleyen zarar', money(pendingCleanupLoss), `planlanan zarar budget ${money(pendingCleanupBudget)}`, pendingCleanupLoss < 0 ? 'warning' : 'secondary'),
    accountingRow('cleanup-executed', 'Cleanup gerçekleşen', money(executedCleanupProfit + executedCleanupLoss), `kar ${money(executedCleanupProfit)} · zarar ${money(executedCleanupLoss)}${cleanupReselectCount ? ` · daraltma ${count(cleanupReselectCount)}` : ''}`, executedCleanupProfit + executedCleanupLoss >= 0 ? 'success' : 'warning'),
    accountingRow('pending-net', 'Close kuyruğu net', money(pendingCloseNet), 'bekleyen kar close + zarar close neti', pendingCloseNet >= 0 ? 'success' : 'warning'),
    accountingRow('executed-close', 'Çalışan close realize', money(executedClose), 'bu kural kararlarından execute edilmiş close PnL', executedClose >= 0 ? 'success' : 'danger'),
    accountingRow('estimated-fee', 'Tahmini close komisyonu', money(-estimatedFees), 'profit-pocket kararlarında tahmini round-trip kalan maliyet', estimatedFees > 0 ? 'warning' : 'secondary'),
    accountingRow('execution-flow', 'Execution akışı', `${count(executionSummary.opened)} açıldı / ${count(executionSummary.skipped)} skip / ${count(executionSummary.failed)} hata`, `mod ${executionSummary.mode || '—'}`, executionSummary.failed > 0 ? 'danger' : 'secondary'),
  ]
  return rows
}

function accountingRow(key, label, value, detail = '', variant = 'secondary') {
  return {
    key, label, value, detail, variant,
  }
}

function decisionProfitPocket(decision) {
  const risk = record(decision && decision.riskSnapshot)
  const pocket = record(risk.profitPocket)
  const closeExecutor = record(risk.closeExecutor)
  const closeApproval = record(risk.closeApproval)
  const executorDone = closeExecutor.status === 'DONE'
  const approvalDone = closeApproval.status === 'DONE'
  const executorFailed = closeExecutor.status === 'FAILED'
  const approvalFailed = closeApproval.status === 'FAILED'
  return {
    type: pocket.type || null,
    netPnlAfterCommissionUsdt: number(pocket.netPnlAfterCommissionUsdt ?? pocket.pnlUsdt, 0),
    estimatedCommissionUsdt: Math.max(0, number(pocket.estimatedCommissionUsdt, 0)),
    plannedLossCoverUsdt: number(record(pocket.profitLossCleanup).plannedLossCoverUsdt ?? record(pocket.partialClose).plannedLossCoverUsdt, 0),
    budgetReselected: record(pocket.profitLossCleanup).budgetReselected === true || record(pocket.partialClose).budgetReselected === true,
    realizedPnl: number(closeExecutor.realizedPnl ?? closeApproval.realizedPnl, 0),
    executed: executorDone || approvalDone || decision.status === 'EXECUTED',
    failed: executorFailed || approvalFailed || decision.status === 'FAILED',
  }
}

function sumPocket(items, predicate, field = 'netPnlAfterCommissionUsdt') {
  return array(items)
    .filter(predicate)
    .reduce((sum, item) => sum + number(item[field], 0), 0)
}

function snapshotRow(key, label, value, detail = '', variant = 'secondary') {
  return {
    key, label, value, detail, variant,
  }
}

function scoreText(value) {
  const score = number(value, NaN)
  return Number.isFinite(score) ? score.toFixed(2) : '—'
}

function scanDetail(scan) {
  const parts = []
  if (scan.symbolCount !== undefined) parts.push(`${count(scan.symbolCount)} coin`)
  if (scan.timeframeCount !== undefined) parts.push(`${count(scan.timeframeCount)} TF`)
  if (scan.filteredSignals !== undefined) parts.push(`${count(scan.filteredSignals)} filtre sonrası`)
  return parts.join(' · ')
}

function pairDetail(pair) {
  const parts = []
  if (pair.primarySide || pair.counterSide) parts.push(`${pair.primarySide || '-'} / ${pair.counterSide || '-'}`)
  if (pair.selectedPairCount !== undefined) parts.push(`${count(pair.selectedPairCount)} pair`)
  if (pair.executablePairCount !== undefined) parts.push(`${count(pair.executablePairCount)} executable`)
  const reasons = reasonListText(pair.reasons)
  if (reasons) parts.push(reasons.replace(/^ · /, ''))
  return parts.join(' · ')
}

function balanceDetail(balance) {
  const parts = []
  if (balance.longCount !== undefined || balance.shortCount !== undefined) {
    parts.push(`LONG ${count(balance.longCount)} / SHORT ${count(balance.shortCount)}`)
  }
  if (balance.maxDirectionalBiasPct !== undefined) parts.push(`maks baskı ${pct(balance.maxDirectionalBiasPct)}`)
  if (balance.reason) parts.push(reasonLabel(balance.reason))
  return parts.join(' · ')
}

function balanceModeLabel(mode) {
  const map = {
    STRICT: 'Sıkı',
    BALANCED: 'Dengeli',
    FLEXIBLE: 'Esnek',
  }
  return map[String(mode || '')] || String(mode || 'Dengeli')
}

function balanceOddSlotPolicyLabel(policy) {
  const map = {
    WAIT: 'bekle',
    TRY_PROFIT_POCKET_UNLOCK: 'kar sepetiyle kilit aç',
    SUGGEST_EXTRA_SLOT: '+1 slot öner',
  }
  return map[String(policy || '')] || String(policy || '—')
}

function balanceGovernorSnapshotValue(balanceGovernor) {
  const snapshot = record(balanceGovernor.snapshot)
  if (!Object.keys(snapshot).length) return balanceModeLabel(balanceGovernor.mode)
  const balanceText = snapshot.balanced === false ? 'dengesiz' : 'dengeli'
  return `${balanceText} · gap ${count(snapshot.sideGap)}`
}

function balanceGovernorVariant(balanceGovernor) {
  const snapshot = record(balanceGovernor.snapshot)
  if (snapshot.balanced === false) return 'warning'
  if (snapshot.oddSlotLocked === true) return 'warning'
  return 'success'
}

function balanceGovernorDetail(balanceGovernor) {
  const snapshot = record(balanceGovernor.snapshot)
  const transmission = record(balanceGovernor.transmission)
  const parts = [
    balanceModeLabel(balanceGovernor.mode),
    `max gap ${count(balanceGovernor.maxSideGap)}`,
  ]
  if (Object.keys(snapshot).length) {
    parts.push(`LONG ${count(snapshot.openLongCount)} / SHORT ${count(snapshot.openShortCount)}`)
    if (snapshot.freeSlots !== undefined && snapshot.freeSlots !== null) parts.push(`boş slot ${count(snapshot.freeSlots)}`)
    if (snapshot.pairCapacity !== undefined && snapshot.pairCapacity !== null) parts.push(`pair kapasite ${count(snapshot.pairCapacity)}`)
    if (snapshot.missingSide) parts.push(`eksik taraf ${snapshot.missingSide}`)
    if (snapshot.oddSlotLocked === true) parts.push('tek slot kilidi')
  }
  parts.push(balanceOddSlotPolicyLabel(balanceGovernor.oddSlotPolicy))
  if (balanceGovernor.rebalanceProtectionEnabled === true) {
    parts.push(`rebalance koruma ${count(balanceGovernor.rebalanceProtectionGraceMinutes)}dk / -%${number(balanceGovernor.rebalanceProtectionMaxLossPct, 0).toFixed(2)} / max ${count(balanceGovernor.rebalanceProtectionMaxClosesPerRun)}`)
  }
  if (balanceGovernor.sequentialDamageTrimEnabled === true) {
    parts.push(`sıralı hasar kırpma -%${number(balanceGovernor.rebalanceProtectionMaxLossPct, 0).toFixed(2)} / %${number(balanceGovernor.sequentialDamageTrimClosePercent, 0).toFixed(0)} · unrealized kar varsa önce kar kapanır`)
  }
  if (Object.keys(transmission).length) {
    parts.push(transmissionDetail(transmission))
  }
  return parts.filter(Boolean).join(' · ')
}

function transmissionModeLabel(mode) {
  const map = {
    SEQUENTIAL: 'sıralı şanzıman',
    ALL_SLOTS: 'tüm slot şanzımanı',
  }
  return map[String(mode || '')] || String(mode || 'şanzıman')
}

function transmissionActionLabel(action) {
  const map = {
    DISABLED: 'pasif',
    NO_OPEN_POSITION: 'pozisyon yok',
    NO_WINNER_SIDE: 'kazanan taraf yok',
    WAIT_STABILITY: 'kararlılık bekliyor',
    PREPARE_TRANSFER: 'seviye refleksi hazır',
    HOLD: 'seviyeyi koru',
  }
  return map[String(action || '')] || String(action || '—')
}

function transmissionTransferActionLabel(action) {
  const map = {
    NONE: 'transfer yok',
    OPEN_NEW_SLOT: 'boş slot',
    RUNTIME_OVERRIDE_NEXT_ENTRY: 'sonraki entry override',
    UNSUPPORTED_EXISTING_POSITION_TRANSFER: 'destek yok',
  }
  return map[String(action || '')] || String(action || '—')
}

function transmissionDetail(transmission) {
  const parts = [
    transmissionModeLabel(transmission.mode),
    transmissionActionLabel(transmission.action),
    transmissionTransferActionLabel(transmission.effectiveTransferAction),
    `L seviye ${number(transmission.longLevel, 0).toFixed(1)} / S ${number(transmission.shortLevel, 0).toFixed(1)}`,
    `L ${count(transmission.longLeverage)}x ${money(transmission.longMarginUsdt)} / S ${count(transmission.shortLeverage)}x ${money(transmission.shortMarginUsdt)}`,
  ]
  if (transmission.winnerSide) parts.push(`önde ${transmission.winnerSide}`)
  if (transmission.marketAlignment) parts.push(`tabela ${String(transmission.marketAlignment).toLowerCase()}`)
  if (transmission.observedStableRuns !== undefined && transmission.requiredStableRuns !== undefined) {
    parts.push(`run ${count(transmission.observedStableRuns)}/${count(transmission.requiredStableRuns)}`)
  }
  if (transmission.startFromActiveLevels === true) {
    parts.push(transmission.activeInitialApplied === true
      ? `aktif başlangıç L ${number(transmission.activeInitialLongLevel, 0).toFixed(1)} / S ${number(transmission.activeInitialShortLevel, 0).toFixed(1)}`
      : 'aktif başlangıç beklemede')
  }
  const lowScoreSwap = record(transmission.lowScoreUncertainSwap)
  if (lowScoreSwap.applied === true) {
    parts.push(`düşük skor swap: ${String(lowScoreSwap.marketDirection || '—')} ${number(lowScoreSwap.marketScore, 0).toFixed(0)}/${number(lowScoreSwap.maxScore, 40).toFixed(0)}`)
  } else if (lowScoreSwap.enabled === true && lowScoreSwap.cooldownReady === false) {
    parts.push(`düşük skor swap cooldown ${count(lowScoreSwap.recentSwapRuns)}/${count(lowScoreSwap.cooldownRequiredRuns)}`)
  }
  const cruiseControl = record(transmission.cruiseControl)
  if (cruiseControl.applied === true) {
    parts.push(`cruise notional yumuşatma: ${String(cruiseControl.marketDirection || '—')} <=${number(cruiseControl.maxNotionalRatio, 1.35).toFixed(2)}`)
  } else if (cruiseControl.enabled === true) {
    parts.push(`cruise beklemede: ${String(cruiseControl.marketDirection || '—')} ${number(cruiseControl.marketScore, 0).toFixed(0)}/${number(cruiseControl.maxScore, 40).toFixed(0)}`)
  }
  if (transmission.transferSupported === false) parts.push('mevcut poz transferi fallback')
  return parts.filter(Boolean).join(' · ')
}

function balanceProfitPocketDetail(summary) {
  const parts = []
  if (summary.sideGap !== undefined) parts.push(`gap ${count(summary.sideGap)}`)
  if (summary.preferredLossOffsetSide) parts.push(`öncelik ${summary.preferredLossOffsetSide}`)
  if (summary.dominantSide) parts.push(`baskın ${summary.dominantSide}`)
  const reasons = reasonListText(summary.lossOffsetPreferenceReasons)
  if (reasons) parts.push(reasons.replace(/^ · /, ''))
  return parts.join(' · ')
}

function cleanupModeLabel(mode) {
  const map = {
    SINGLE_POSITION: 'tek pozisyon',
    TOTAL_POSITIVE_PNL: 'toplam pozitif PnL',
  }
  return map[String(mode || '')] || String(mode || '—')
}

function realizedProfitDistributionTimingLabel(timing) {
  const map = {
    ACTIVE_AND_CLOSED_BUDGET: 'aktif pozisyona margin ekle ve kapalı olanların bütçelerine dahil et',
    NEW_POSITION_BUDGET: 'yeni pozisyonların bütçelerine ekle',
  }
  return map[String(timing || '')] || String(timing || '—')
}

function realizedProfitDistributionTimingShortLabel(timing) {
  const map = {
    ACTIVE_AND_CLOSED_BUDGET: 'aktif + kapalı bütçe',
    NEW_POSITION_BUDGET: 'yeni pozisyon bütçesi',
  }
  return map[String(timing || '')] || String(timing || '—')
}

function realizedProfitDistributionDetail(distribution) {
  return [
    `realize buffer ${money(distribution.realizedProfitBufferUsdt)}`,
    `aktif poz ${count(distribution.activePositionCount)}`,
    `bot başı ${money(distribution.estimatedActivePositionShareUsdt)}`,
    `effective margin ${money(distribution.effectiveMarginPerBotUsdt)}`,
  ].join(' · ')
}

function profitPocketDetail(pocket) {
  const parts = []
  if (pocket.availableLossCoverUsdt !== undefined) parts.push(`zarar cover ${money(pocket.availableLossCoverUsdt)}`)
  if (pocket.decisionCount !== undefined) parts.push(`${count(pocket.decisionCount)} karar`)
  const skipped = array(pocket.skippedReasons)
  if (skipped.length) parts.push(skipped.slice(0, 2).map(reasonLabel).join(' · '))
  return parts.join(' · ')
}

function profitLossCleanupDetail(cleanup) {
  const parts = [
    cleanupModeLabel(cleanup.mode),
    `budget ${money(cleanup.estimatedCleanupBudgetUsdt)}`,
  ]
  if (cleanup.partialLossEnabled === true) parts.push('partial açık')
  if (cleanup.partialLossCount !== undefined) parts.push(`partial ${count(cleanup.partialLossCount)}`)
  const rejected = array(cleanup.rejectedReasons)
  if (rejected.length) parts.push(rejected.slice(0, 2).map(reasonLabel).join(' · '))
  return parts.filter(Boolean).join(' · ')
}

function safeCloseStatusLabel(status) {
  const map = {
    DISABLED: 'kapalı',
    NO_OPEN_POSITION: 'pozisyon yok',
    READY_TO_CLOSE: 'kapanış hazır',
    WAITING_PROFIT: 'kar bekliyor',
    TARGET_NOT_REACHED: 'hedef bekliyor',
  }
  return map[String(status || '')] || String(status || '—')
}

function safeCloseDetail(safeClose) {
  const parts = [
    `kar ${money(safeClose.positiveNetPnlUsdt)}`,
    `zarar ${money(safeClose.negativeNetPnlUsdt)}`,
    `cover ${money(safeClose.availableProfitCoverUsdt)}`,
    `giveback ${pct(safeClose.profitGivebackPercent)}`,
  ]
  if (safeClose.selectedProfitCount !== undefined || safeClose.selectedLossCount !== undefined) {
    const neutralCount = count(safeClose.selectedNeutralCount ?? array(safeClose.selectedNeutralPositions).length)
    parts.push(`${count(safeClose.selectedProfitCount ?? array(safeClose.selectedProfitPositions).length)} kar / ${count(safeClose.selectedLossCount ?? array(safeClose.selectedLossPositions).length)} zarar / ${neutralCount} nötr`)
  }
  if (safeClose.blockedEntryCount) parts.push(`${count(safeClose.blockedEntryCount)} entry durdu`)
  if (safeClose.ruleDisabled === true) parts.push('kural pasife alındı')
  const rejected = array(safeClose.rejectedReasons)
  if (rejected.length) parts.push(rejected.slice(0, 2).map(reasonLabel).join(' · '))
  return parts.filter(Boolean).join(' · ')
}

function reasonListText(reasons) {
  const labels = array(reasons).slice(0, 3).map(reasonLabel)
  return labels.length ? ` · ${labels.join(' · ')}` : ''
}

function row(key, group, label, value, detail = '', variant = 'secondary') {
  return {
    key,
    group,
    label,
    value,
    detail,
    variant,
  }
}

export function reasonLabel(reason) {
  const code = String(reason || '')
  return REASON_LABELS[code] || code.toLowerCase().replace(/_/g, ' ') || 'neden yok'
}
